import { createStripeConnectAccount } from '../../../services/vault/stripeConnectAccount';
import { createStripePerson } from '../../../services/vault/stripePerson';
import { StripeEnv } from '../../../util/enums';
import { StripeMetadataInput } from '../../VaultForm';

export type StripeEntities = {
  connectAccountId: string;
  personId: string;
};

export type UnitEntities = {};

export type ProviderEntities = {
  stripeEntities?: StripeEntities;
  unitEntities?: UnitEntities;
};

export async function createProviderEntities({
  provider,
  kybId,
  kycId,
  stripeEnv,
  statementDescriptor,
  metadata,
}: {
  provider: VaultProvider;
  kybId?: string;
  kycId?: string;
  stripeEnv?: StripeEnv;
  statementDescriptor?: string;
  metadata?: StripeMetadataInput;
}): Promise<ProviderEntities> {
  if (provider === 'stripe') {
    if (kybId === undefined) {
      throw new Error('kyb id undefined');
    }
    if (kycId === undefined) {
      throw new Error('kyc id undefined');
    }
    const connectAccountId = await createStripeConnectAccount(
      kybId,
      statementDescriptor,
      metadata,
      stripeEnv,
    );
    const personId = await createStripePerson(
      kycId,
      connectAccountId,
      stripeEnv,
    );
    return {
      stripeEntities: {
        connectAccountId,
        personId,
      },
    };
  } else if (provider === 'unit') {
    throw new Error('OrgConfirmation unit not implemented');
  } else {
    throw new Error(`Unknown provider ${provider}`);
  }
}
